'use client';

import { Children } from 'react';
import { useTheme } from '@mui/material';
import { mergeSx } from '@jucy-ui/appearance';
import { JucySlider, JucySliderProps } from '@jucy-ui/components/JucySlider';

export type ResponsiveSliderProps = JucySliderProps;

export const ResponsiveSlider = ({ children, ...props }: ResponsiveSliderProps) => {
    const theme = useTheme();
    const slideCount = children ? Children.count(children) : 0;
    return (
        <JucySlider
            key={`slider-${slideCount}`}
            adaptiveHeight={props.adaptiveHeight || false}
            showDots={props.showDots || false}
            showNav={props.showNav || true}
            config={{
                all: {
                    loop: false,
                    slideGap: theme.spacing(3),
                },
                xs: { slidesToShow: 1 },
                sm: { slidesToShow: 2 > slideCount ? slideCount : 2 },
                md: { slidesToShow: 3 > slideCount ? slideCount : 3 },
                lg: { slidesToShow: 3 > slideCount ? slideCount : 3 },
                xl: { slidesToShow: 3 > slideCount ? slideCount : 3 },
                xxl: { slidesToShow: 3 > slideCount ? slideCount : 3 },
            }}
            componentProps={{
                ...props.componentProps,
                container: {
                    ...props.componentProps?.container,
                    sx: mergeSx(
                        {
                            mx: {
                                md: -1.5,
                            },
                            '& .slider-list > .slide': {
                                display: 'flex',
                                justifyContent: 'center',
                            },
                        },
                        props.componentProps?.container?.sx
                    ),
                },
            }}
        >
            {children}
        </JucySlider>
    );
};
